<template>
  <div class="d-none" />
</template>

<script>
import Listable from '@/components/mixins/listable';

export default {
  name: 'AppointmentInvitationsListableManager',
  mixins: [Listable],
  props: {
    searchTerm: {
      type: String,
      default: '',
    },
    kwargs: {
      type: Object,
      default: () => {},
    },

    // listable options
    source: {
      type: String,
      default: 'invitations',
    },
    mode: {
      type: String,
      default: 'loadMore',
    },
    pageSize: {
      type: Number,
      default: 15,
    },
    noMultiRequest: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    fetchRoute() {
      if (this.mode === 'loadMore') {
        return `${this.source}/addAppointmentInvitationsActivity`;
      }
      const err = { message: `${this.source} only supports 'loadMore' listable mode.` };
      throw err;
    },
  },
  watch: {
    kwargs: {
      immediate: true,
      handler(newVal) {
        this.queryParams = newVal;
      },
    },
    elements(newVal) {
      this.$emit('input', { count: this.count, items: newVal });
    },
    searchTerm: {
      immediate: true,
      handler(newVal) {
        this.search = newVal;
      },
    },
  },
};
</script>

<style lang="css" scoped>
</style>
